import { render, staticRenderFns } from "./TranslationDraftCreate.vue?vue&type=template&id=525aab85"
import script from "./TranslationDraftCreate.vue?vue&type=script&lang=js"
export * from "./TranslationDraftCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports